import { IsBoolean, IsDefined, IsInt, IsOptional} from 'class-validator';
import { Exclude } from 'class-transformer';
import { BaseDto } from '../base.dto';

/**
 * DTO object for creation of Brand Member.
 */
export class BrandMemberCreateDto extends BaseDto {
  @IsDefined()
  @IsInt()
  brandId: number;

  @IsDefined()
  @IsInt()
  customerId: number;

  @IsDefined()
  @IsInt()
  membershipTypeId: number;

  @Exclude()
  code: string;

  @IsDefined()
  @IsBoolean()
  active: boolean;

  @IsOptional()
  appleWalletS3Link: string;

  @IsOptional()
  googleWalletJwtLink: string;
}
